(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    // Controle aprimorado para vídeos sem controles
  document.addEventListener('DOMContentLoaded', function() {
    const videosWithoutControls = document.querySelectorAll('.video-controls-disabled:not(.video-hide-all-controls)');
    
    videosWithoutControls.forEach(function(videoContainer) {
      const toggleButton = videoContainer.querySelector('[ref="toggleMediaButton"]');
      const playIcon = videoContainer.querySelector('.icon-play');
      const pauseIcon = videoContainer.querySelector('.icon-pause');
      
      if (toggleButton) {
        toggleButton.addEventListener('click', function() {
          const iframe = videoContainer.querySelector('iframe');
          const video = videoContainer.querySelector('video');
          
          if (iframe) {
            // Controle para YouTube/Vimeo via postMessage
            const isPlaying = !playIcon.classList.contains('hidden');
            
            if (iframe.classList.contains('js-youtube')) {
              iframe.contentWindow.postMessage(
                '{"event":"command","func":"' + (isPlaying ? 'pauseVideo' : 'playVideo') + '","args":""}',
                '*'
              );
            } else if (iframe.classList.contains('js-vimeo')) {
              iframe.contentWindow.postMessage(
                '{"method":"' + (isPlaying ? 'pause' : 'play') + '"}',
                '*'
              );
            }
            
            // Toggle icons
            playIcon.classList.toggle('hidden');
            pauseIcon.classList.toggle('hidden');
          } else if (video) {
            // Controle para vídeos nativos
            if (video.paused) {
              video.play();
              playIcon.classList.add('hidden');
              pauseIcon.classList.remove('hidden');
            } else {
              video.pause();
              playIcon.classList.remove('hidden');
              pauseIcon.classList.add('hidden');
            }
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
